import React from "react";

export default function OrdersBlockSm() {
    return (<div>123</div>)
}